<div
  class="chip-content"
  [ngClass]="{ conflict: hasConflict, unavailable: isUnavailable || isBookedOff }"
>
  <div
    class="chip-details"
    (mouseenter)="onConflictHover($event)"
    (mouseleave)="onConflictLeave()"
  >
    <p-avatar
      *ngIf="hasConflict; else noConflict"
      [icon]="panelType === 'right' ? 'pi pi-exclamation-triangle' : panelType === 'dialog' ? icon :null"
      [image]="panelType === 'dialog' && imageUrl"
      [label]="
        panelType === 'dialog' && !imageUrl && !icon
          ? name.charAt(0).toUpperCase()
          : null
      "
      shape="circle"
      class="transparent-bg"
    ></p-avatar>

    <ng-template #noConflict>
      <p-avatar
        [image]="imageUrl"
        [label]="!imageUrl && !icon ? name.charAt(0).toUpperCase() : null"
        [icon]="icon ? icon : null"
        shape="circle"
        [style]="{
          'background-color': !imageUrl && !icon ? '#c9ffa97d' : 'transparent',
        }"
      ></p-avatar>
    </ng-template>

    <span class="name">
      {{ name }}
    </span>

    <!-- Conflict hover: overlay listing the conflicting events + their assets.
         Rendered inside the always-present .chip-details so the hover
         bindings never reference an embedded view from outside (NG9). -->
    <p-overlayPanel #conflictOp *ngIf="hasConflict">
      <ng-template pTemplate>
        <div class="conflict-tooltip">
          <div class="conflict-tooltip-title">
            <i class="pi pi-exclamation-triangle"></i>
            Double-booked
          </div>
          @for (conflict of conflictDetails; track conflict.id) {
            <div class="conflict-event">
              <div class="conflict-event-title">{{ conflict.title }}</div>
              <div class="conflict-time">{{ conflict.time }}</div>
              <div class="conflict-assets">{{ conflict.assets }}</div>
            </div>
          }
        </div>
      </ng-template>
    </p-overlayPanel>

    <span
      class="icon crew-lead-icon"
      *ngIf="showStar"
      pTooltip="Crew Lead"
      tooltipPosition="top"
    >
      <i class="pi pi-star-fill"></i>
    </span>
    <span
      class="icon locked"
      *ngIf="showLocked"
    >
      <i class="pi pi-lock"></i>
    </span>
    <span
      class="icon"
      *ngIf="isDriver"
    >
      <i class="pi pi-steering-wheel pi-custom"></i>
    </span>
    <span
      class="icon"
      *ngIf="isOvertime"
    >
      <i
        class="pi pi-clock"
        style="color: var(--orange-500);"
      ></i>
    </span>
    <span
      class="icon"
      *ngIf="isAssigned && !hasConflict"
      pTooltip="Assigned to an event"
    >
      <i
        class="pi pi-check-circle"
        style="color: var(--green-500);"
      ></i>
    </span>
  </div>

  <div class="p-d-flex chip-meta-info">
    <ng-container *ngIf="!hasConflict">
      <span
        class="name"
        *ngIf="eventsCount !== null || revenue !== null || tooltipText"
      >
        <button
          type="button"
          *ngIf="rateHourly !== null"
          class="edit-icon p-mr-3"
          aria-label="Edit rate"
          (click)="onEdit(); $event.stopPropagation()"
        >
          <i class="pi pi-pencil"></i>
        </button>
        <ng-container *ngIf="eventsCount !== null || revenue !== null || tooltipText">
          <p-overlayPanel #op>
            <ng-template pTemplate>
              <app-dispatch-tooltip
                [name]="name"
                [imageUrl]="imageUrl"
                [icon]="icon"
                [eventsCount]="eventsCount"
                [revenue]="revenue"
                [panelType]="panelType"
                [text]="tooltipText"
              ></app-dispatch-tooltip>
            </ng-template>
          </p-overlayPanel>
          <!-- D-7 (Maria): the info icon opens the crew modal on click,
               consistent with the sidebar crew list. -->
          <button
            type="button"
            class="info-icon"
            aria-label="Details"
            (mouseenter)="op.show($event)"
            (mouseleave)="op.hide()"
            (click)="onEdit(); $event.stopPropagation()"
          >
            <i class="pi pi-info-circle"></i>
          </button>
        </ng-container>
      </span>
    </ng-container>
    <ng-container *ngIf="hasConflict && panelType === 'dialog'">
      <span class="name"> Conflict </span>
    </ng-container>
    <button
      type="button"
      class="remove-icon p-ml-3"
      aria-label="Remove"
      (click)="onRemove()"
      *ngIf="removable"
    >
      <i class="pi pi-times"></i>
    </button>
  </div>
</div>